var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product__island bg-shade-light py-prj px-prj2 px-3@large" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "small-12 medium-4 column d-flex py-prj py-2@large" },
          [
            _c(
              "div",
              {
                staticClass:
                  "bg-shade d-flex flex-child-auto align-items-center",
              },
              [
                _c(
                  "figure",
                  {
                    staticClass:
                      "bg-shade product__figure embed-responsive embed-responsive-1/1",
                  },
                  [
                    _c("img", {
                      staticClass: "object-fit-contain",
                      attrs: {
                        src: _vm.imgurl,
                        alt: _vm.globalConfig.productimg_metatitle,
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "small-12 medium-8 column d-flex" },
          [_vm._t("default")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }